import { ApiResultVoCommonAreaResponseVo } from '@schemas/non-auth'
import { createPrefetchQuery } from '@utils/createPrefetchQuery'
import { fetchAPI } from '@utils/http/apiRequest'
import { useQuery } from '@tanstack/react-query'

interface YoutubeSnsReqModel {
	areaIdx?: number
	pageNo?: number
	pageSize?: number
}

const path = '/restapi/v1/get/template/news-home/youtube-sns'
const queryKeyString = ['@template/news-home/youtube-sns'] as const

const getQuery = async (
	props: YoutubeSnsReqModel,
	cookieHeader?: string,
): Promise<ApiResultVoCommonAreaResponseVo> => {
	const { areaIdx, pageNo, pageSize } = props
	const params = new URLSearchParams({
		...(areaIdx ? { areaIdx: String(areaIdx) } : {}),
		...(pageNo ? { pageNo: String(pageNo) } : {}),
		...(pageSize ? { pageSize: String(pageSize) } : {}),
	})
	return fetchAPI({ path, params, cookieHeader })
}

export const queryYoutubeSns = (props: YoutubeSnsReqModel, cookieHeader?: string) => ({
	queryKey: [...queryKeyString],
	queryFn: () => getQuery(props, cookieHeader),
})

export const prefetchYoutubeSns = (props: YoutubeSnsReqModel, cookieHeader?: string) =>
	createPrefetchQuery(queryKeyString, () => getQuery(props, cookieHeader))

export const useRefetchYoutubeSns = (
	props: YoutubeSnsReqModel,
	cookieHeader?: string,
	enabled = true,
) => {
	return useQuery({
		queryKey: [...queryKeyString],
		queryFn: () => getQuery(props, cookieHeader),
		refetchInterval: 1000 * 60,
		enabled,
	})
}
